import React, { type JSX } from 'react'
import styled from '@emotion/styled'
import { Button } from '@mobi/component-library/Base/Buttons'
import { colors, font } from '@mobi/component-library/Foundations'
import bonusBetOrCashEmptyStateSvgPath from './assets/bonusEmptyState.svg'
import bonusOffersEmptyStateSvgPath from './assets/offersEmptyState.svg'

export interface BonusOffersEmptyStateModel {
  mode: 'BonusBet' | 'BonusCash' | 'BonusOffer'
  onShowHelpDetailsClicked: null | (() => void)
}

interface BonusOffersEmptyStateProps {
  model: BonusOffersEmptyStateModel
}

export const BonusOffersEmptyState = ({
  model,
}: BonusOffersEmptyStateProps): JSX.Element | null => {
  return (
    <WrapperStyled>
      <div>
        <img
          src={
            model.mode === 'BonusOffer'
              ? bonusOffersEmptyStateSvgPath
              : bonusBetOrCashEmptyStateSvgPath
          }
          width='333'
          height='206'
          alt='Empty Bonus List'
        />
      </div>

      <div>
        {model.mode === 'BonusOffer' && <div>No Bonus Offers Available</div>}
        {model.mode === 'BonusBet' && <div>No Bonus Bets Available</div>}
        {model.mode === 'BonusCash' && <div>No Bonus Cash Available</div>}

        <div>
          {model.mode === 'BonusOffer' && (
            <p>When you have Bonus Offers available they will appear here.</p>
          )}
          {model.mode === 'BonusBet' && (
            <p>When you have Bonus Bets available they will display here.</p>
          )}
          {model.mode === 'BonusCash' && (
            <p>When you have Bonus Cash available it will display here.</p>
          )}
        </div>

        <div>
          {model.mode !== 'BonusOffer' && !!model.onShowHelpDetailsClicked && (
            <Button color='tertiary_grey' onClick={model.onShowHelpDetailsClicked} size='xs'>
              What is {model.mode === 'BonusBet' ? 'a Bonus Bet' : 'Bonus Cash'}?
            </Button>
          )}
        </div>
      </div>
    </WrapperStyled>
  )
}

const WrapperStyled = styled.div({
  backgroundColor: colors.surface[300],

  ' > div:nth-of-type(1)': {
    paddingTop: '10vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  ' > div:nth-of-type(2)': {
    '> div:nth-of-type(1)': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: font.family.primary,
      fontWeight: font.weight.semibold,
      fontSize: font.size.lg.fontSize,
      lineHeight: font.size.lg.lineHeight,
    },
    '> div:nth-of-type(2)': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      maxHeight: '5rem',
      p: {
        textAlign: 'center',
        maxWidth: '24rem',
        fontFamily: font.family.primary,
        fontWeight: font.weight.regular,
        fontSize: font.size.lg.fontSize,
        lineHeight: font.size.lg.lineHeight,
      },
    },
    '> div:nth-of-type(3)': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',

      button: {
        marginTop: '3rem',
        fontFamily: font.family.primary,
        fontWeight: font.weight.medium,
        fontSize: font.size.lg.fontSize,
        lineHeight: font.size.lg.lineHeight,
        color: colors.lavender[700],
      },
    },
  },
})
